import { Chip } from '@mui/material';
import { formatDisplayDate } from '../../Helpers/dateHelpers';

/** Row style for cancelled bookings, shared by the bookings list and the offer bookings table. */
export const CANCELLED_ROW_SX = { opacity: 0.6, backgroundColor: 'action.hover' };

interface CancelledBookingChipProps {
  cancelledAtUtc?: string | null;
}

/** Renders nothing for active bookings; cancellation is keyed off `cancelledAtUtc`, never the status. */
const CancelledBookingChip = ({ cancelledAtUtc }: CancelledBookingChipProps) => {
  if (!cancelledAtUtc) {
    return null;
  }

  const description = `Anulowano: ${formatDisplayDate(cancelledAtUtc)}`;

  return (
    <Chip label="Anulowany" color="default" size="small" title={description} aria-label={description} />
  );
};

export default CancelledBookingChip;
